<template>
  <div class="home">
    <Intro />
    <About />
    <Portfolio />
    <Contact />
  </div>
</template>

<script>
// @ is an alias to /src
import Intro from "@/components/Intro.vue";
import About from "@/components/About.vue";
import Portfolio from "@/components/Portfolio.vue";
import Contact from "@/components/Contact.vue";

export default {
  name: "home",
  components: {
    Intro,
    Portfolio,
    About,
    Contact
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
  mounted() {
    const fadeIns = document.querySelectorAll(".fade-in");
    const rightSliders = document.querySelectorAll(".right-slide");
    const leftSliders = document.querySelectorAll(".left-slide");
    const upSliders = document.querySelectorAll(".up-slide");
    const downSliders = document.querySelectorAll(".down-slide");
    const appearOptions = {
      threshold: 1,
      rootMargin: "0px 0px -10% 0px"
    };

    const appearOnScroll = new IntersectionObserver(
      (entries, appearOnScroll) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          } else {
            entry.target.classList.add("animate");
            appearOnScroll.unobserve(entry.target);
          }
        });
      },
      appearOptions
    );

    fadeIns.forEach(fadeIn => {
      appearOnScroll.observe(fadeIn);
    });

    rightSliders.forEach(rightSlider => {
      appearOnScroll.observe(rightSlider);
    });

    leftSliders.forEach(leftSlider => {
      appearOnScroll.observe(leftSlider);
    });

    upSliders.forEach(upSlider => {
      appearOnScroll.observe(upSlider);
    });

    downSliders.forEach(downSlider => {
      appearOnScroll.observe(downSlider);
    });
  }
};
</script>

<style lang="scss" scoped>
</style>